import { Notification } from 'element-ui';

export default Notification;
